package com.fireavert.smsFlow.server

object SMSValidator {
    private const val SMS_REGEX = "^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}\$"
    fun isSMSValid(sms: String): Boolean {
        return SMS_REGEX.toRegex().matches(sms)
    }
}